import React from "react";
import { Checkbox } from "@/components/ui/Checkbox";
import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";

const TableList = ({
  tables = [],
  selectedTables = new Set(),
  onToggleSelect,
  onSeparate,
}) => {
  console.log(tables);
  const canSelectTable = (table) => {
    if (!table) return false;
    return (
      table.joinTable === "SI" &&
      (table.tableStatus === "ACTIVA" || table.tableStatus === "CREADA")
    );
  };

  if (!Array.isArray(tables)) {
    return (
      <div className="text-center py-4 text-gray-500">
        No hay mesas disponibles
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      {tables.length === 0 ? (
        <div className="text-center py-4 text-gray-500">
          No hay mesas para mostrar
        </div>
      ) : (
        <table className="w-full min-w-[600px]">
          <thead className="border-b border-orange-200">
            <tr>
              <th className="px-4 py-3 text-left">Seleccionar</th>
              <th className="px-4 py-3 text-left">Identificador</th>
              <th className="px-4 py-3 text-left">Nombre de Mesa</th>
              <th className="px-4 py-3 text-left">Ubicación</th>
              <th className="px-4 py-3 text-center">Asientos</th>
              <th className="px-4 py-3 text-center">¿Se puede unir?</th>
              <th className="px-4 py-3 text-center">Estado</th>
              <th className="px-4 py-3 text-center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {tables.map((table) => (
              <tr
                key={table.mesaId}
                className={cn(
                  "border-b border-orange-100 hover:bg-orange-50",
                  !canSelectTable(table) && "opacity-60"
                )}
              >
                <td className="px-4 py-3">
                  <div className="relative">
                    <Checkbox
                      checked={selectedTables.has(table.mesaId)}
                      onCheckedChange={(checked) =>
                        onToggleSelect(table.mesaId, checked)
                      }
                      disabled={!canSelectTable(table)}
                      className={cn(
                        "border-orange-200",
                        "data-[state=checked]:bg-orange-500",
                        "data-[state=checked]:border-orange-500",
                        !canSelectTable(table) &&
                          "cursor-not-allowed opacity-50"
                      )}
                    />
                    {!canSelectTable(table) && (
                      <div className="absolute left-0 -bottom-5 text-xs text-gray-500">
                        {console.log(
                          "---> ",
                          table.mesaId,
                          " -- ",
                          table.isJoined
                        )}
                        {table.joinTable !== "SI"
                          ? "No se puede unir"
                          : "Estado no válido"}
                      </div>
                    )}
                  </div>
                </td>
                <td className="px-4 py-3">{table.mesaId}</td>
                <td className="px-4 py-3">{table.descriptionMesa || "-"}</td>
                <td className="px-4 py-3">{table.ubication}</td>
                <td className="px-4 py-3 text-center">{table.cantAsientos}</td>
                <td className="px-4 py-3 text-center">
                  <span
                    className={cn(
                      "px-2 py-1 rounded-full text-xs",
                      table.joinTable === "SI"
                        ? "bg-green-100 text-green-800"
                        : "bg-gray-100 text-gray-800"
                    )}
                  >
                    {table.joinTable === "SI" ? "Sí" : "No"}
                  </span>
                </td>
                <td className="px-4 py-3 text-center">
                  <span
                    className={cn(
                      "px-2 py-1 rounded-full text-xs font-medium",
                      {
                        "bg-green-100 text-green-800":
                          table.tableStatus === "ACTIVA" ||
                          table.tableStatus === "CREADA",
                        "bg-yellow-100 text-yellow-800":
                          table.tableStatus === "EN_CURSO",
                        "bg-red-100 text-red-800":
                          table.tableStatus === "CERRADA",
                      }
                    )}
                  >
                    {table.tableStatus}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <div className="flex justify-center gap-2">
                    {(table.tableStatus === "ACTIVA" ||
                      table.tableStatus === "CREADA") && (
                      <>
                        {table.isJoined ? (
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => onSeparate(table.mesaId)}
                            className="border-orange-200 hover:bg-orange-100"
                          >
                            Separar
                          </Button>
                        ) : null}
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TableList;
